module.exports = __webpack_public_path__ + "static/media/PLAY.df038900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PLAY.png
// module id = 291
// module chunks = 0